import { Listbox } from '@headlessui/react';
import type { Dispatch, MouseEvent, SetStateAction } from 'react';

import { ReactComponent as ArrowDownIcon } from 'assets/icons/sz/arrow-down.svg';
import { ReactComponent as TrashIcon } from 'assets/icons/sz/trash-icon.svg';
import { useIsMobile } from 'hooks';
import { validateCard, validateCardType, twMergeClsx } from 'utils';

export const renderIcon = (cardNumber: string) => {
  const CardBank = validateCard(cardNumber);

  if (CardBank) {
    return <div>{CardBank}</div>;
  }

  const CardType = validateCardType(cardNumber);

  if (CardType) {
    return <CardType />;
  }

  return <div />;
};

type CardOptionType = {
  crypt?: string;
  maskedPan: string;
  bankBin?: string;
  newCard?: boolean;
  id: number;
};

const defaulValue = { maskedPan: 'Новая карта', newCard: true };

const SelectCard = ({
  selectedCard,
  cards,
  handleDelete,
  setSelectedCard,
}: {
  cards: CardOptionType[];
  selectedCard: CardOptionType;
  handleDelete: (value: string) => void;
  setSelectedCard: Dispatch<SetStateAction<CardOptionType>>;
}) => {
  const { isMobile } = useIsMobile();
  const renderBtnContent = () => {
    if (selectedCard) {
      if (selectedCard.newCard) {
        return <span className="flex-grow">{selectedCard.maskedPan}</span>;
      }

      return selectedCard.bankBin ? (
        <>
          {renderIcon(selectedCard.bankBin)}
          <span className="flex-grow">{selectedCard.maskedPan}</span>
        </>
      ) : null;
    }

    return null;
  };

  const deleteCard = (e: MouseEvent<HTMLButtonElement>, pan: string) => {
    handleDelete(pan);
    e.stopPropagation();
  };

  return (
    <Listbox as="div" className="relative" value={selectedCard} onChange={setSelectedCard}>
      {({ open }) => (
        <>
          {open && isMobile && (
            <div className="bg-black/70 fixed top-0 left-0 w-full z-10 h-screen" />
          )}
          <Listbox.Button className="z-10 relative px-4 py-3 w-full text-left bg-sz-gray-100 outline-none h-[46px] rounded-[12px] text-base text-black font-semibold flex items-center gap-[10px] leading-6 border border-solid border-sz-gray-200 hover:border-sz-yellow-200 focus:border-sz-yellow-200">
            {renderBtnContent()}
            <ArrowDownIcon
              className={twMergeClsx(
                'w-5 h-5 transition-transform fill-1xbet-black',
                open && 'rotate-180',
              )}
            />
          </Listbox.Button>
          <Listbox.Options className="absolute border-sz-gray-200 border w-full z-50 rounded-[10px] bg-sz-gray-100 mt-1 overflow-hidden">
            <Listbox.Option
              className="px-4 py-3 border-b border-b-sz-gray-600 last:border-none hover:bg-sz-gray-600 cursor-pointer transition-colors"
              value={defaulValue}
            >
              {defaulValue.maskedPan}
            </Listbox.Option>
            {cards?.map((item) => (
              <Listbox.Option
                className="px-4 py-3 border-b border-b-sz-gray-600 last:border-none hover:bg-sz-gray-600 cursor-pointer transition-colors flex items-center gap-[10px]"
                value={item}
                key={item.maskedPan}
              >
                {item.bankBin && renderIcon(item.bankBin)}
                <span className="flex-grow">{item.maskedPan}</span>
                <button
                  className="w-6 h-6"
                  type="button"
                  onClick={(e) => deleteCard(e, item.maskedPan)}
                >
                  <TrashIcon className="fill-1xbet-black" />
                </button>
              </Listbox.Option>
            ))}
          </Listbox.Options>
        </>
      )}
    </Listbox>
  );
};

export { SelectCard };
